import singleTaskTemplate from './tasks.task.html';
import TaskController from './TaskController';

const module = angular.module('websked.tasks.task', []);

const toLoad = [
  TaskController
];

toLoad.forEach(fn => fn(module));

function singleTaskRoute($stateProvider) {
  $stateProvider
    .state('tasks.task', {
      url: '/task/:id',
      controller: 'TaskController',
      template: singleTaskTemplate,
      data: {
        pageTitle: {
          de: 'Aufgabe',
          en: 'Task',
          es: 'Tarea',
          fr: 'Tâche'
        }
      }
    });
}

module.config(['$stateProvider', singleTaskRoute]);
